import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
const META_PIXEL_ID = '1367632915547845';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white text-navy selection:bg-gold/30 selection:text-navy-dark" data-id="element-0" data-mp="swgm3tmn7arr">
      <noscript data-id="element-1" data-mp="3uct2xiigokzy">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="3udayecxauv6t" />
      </noscript>
      <main data-id="element-3" data-mp="86w6svjrae2f">
        <Hero data-id="element-4" data-mp="8648ve2os48z" />
        <TestimonialsStrip data-id="element-5" data-mp="83i2hhrj7usc" />
        <PainPoints data-id="element-6" data-mp="3gl4rzijy82kk" />
        <SolutionReveal data-id="element-7" data-mp="3gklbm69y5m8n" />
        <VolumesSection data-id="element-8" data-mp="3glwc9x83idvj" />
        <BonusSection data-id="element-9" data-mp="3gja2rs1n9oao" />
        <PricingSection data-id="element-10" data-mp="3bmjsxmgfnoxp" />
        <ExtendedTestimonials data-id="element-11" data-mp="3bncpxvplb02n" />
        <Guarantee data-id="element-12" data-mp="3bo4kr4bd4trv" />
        <FAQ data-id="element-13" data-mp="3bkgs07dqsbe7" />
        <FinalCTA data-id="element-14" data-mp="3qaxs9nen4v9i" />
      </main>
      <Footer data-id="element-15" data-mp="3qc95edtz7fda" />
    </div>;
}